import { signup_email } from '@/libs/schema/schema';
import { escapeRegExp } from './escapeRegExp';

export const checkEmailChar = (val: string, email: string) => {
  return val.search(escapeRegExp(email.split('@')[0] ?? '')) === -1;
};

export const checkEmailFormat = (val: string) => signup_email.safeParse(val).success;
